<div
  [ngClass]="{ staticStroke: staticStroke }"
  class="icon color-{{ color }} colorFill-{{ colorFill }} size-{{
    size
  }} strokeWidth-{{ strokeWidth }} {{ classess }}"
  [inlineSVG]="iconPath"
></div>
